<vp-hotel-by-deal-card-list
	[editableInStoryblok]="_editable"
	[highlightedHotelSlug]="(highlightedHotelSlug$ | async) || ''"
	[hotelbydeals]="hotelList"
/>
